/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CirclePlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdUlEQVR4nMVVTU/CQBBtvKg34YjGX2LgSmh3ZjhsZ4KJFf0PxuhvEvgbatQjGG/q3c87ZgjaltZ2IY1uMsle9r2d93beet5/LmttHUiOAGVkSCZA/Kk13w8Bwr7v92qrAG8C8TkQvwHJtKgMyqtBPtMzTuAA0gCUqzJgWCQivgsCu1sI3u3u7wDJ87Lg8NMNP/m+3f5dFpSbVcEh7uS6FUUbWWlmmhcfDgK714GwWU7Ep4u3r7sY6nnempaL8anXZZCPXdr3HAnmfhzG8qCMKicgHiT0l4fqCWQSS0TynmfoN2BZ5RmvmIUEesiVIAhsq5gA5b5qiQB5nJyBYfUEcpHIn7BfOQGEB6lB0+GoisAQvyBGW6lp1sgtO9iBsJlnaIYA5SSTRRpQGlRO7VMROF/mhp0ujVqN3JXBSR71P8kFjw2Xht5ieXC+Lf1wknJp5LoYr4aq5u12e90JPC1Zr6apOJsT5LFB+dCa7YkHhiTKvJa/Xl9HCbtg8tXWPgAAAABJRU5ErkJggg==)
 */
export const CirclePlusIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm0-17a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4V7a1 1 0 0 1 1-1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
